module.exports = __webpack_public_path__ + "static/media/CoreA1_positivo.0f1670a5.png";